const config = {
    "aws_user_pools_web_client_id": "7ctuh4ca166aor7gohflsat1ec",  //"aws_user_pools_web_client_id": "2t7cskqh488ncdmhu536g5tsfa",     // CognitoClientID
    "cognito_hosted_domain": "defcon-29.auth.us-east-1.amazoncognito.com",                   // CognitoDomainName
    "redirect_url": "https://prod.d3m9npb15pqx4b.amplifyapp.com/",
    "api_base_url": "https://mx3znoiwmb.execute-api.us-east-1.amazonaws.com/dev"                        // AmplifyURL (temporary fix) //"api_base_url": "https://054x4dskg8.execute-api.us-east-1.amazonaws.com/dev"
  };
  
export default config;